'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _propTypes = require('prop-types');

var _propTypes2 = _interopRequireDefault(_propTypes);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var ContactInformation = function (_Component) {
  _inherits(ContactInformation, _Component);

  function ContactInformation(props) {
    _classCallCheck(this, ContactInformation);

    var _this = _possibleConstructorReturn(this, (ContactInformation.__proto__ || Object.getPrototypeOf(ContactInformation)).call(this, props));

    var shouldShowAddress = false;
    if (props.initialshouldShowAddress !== undefined && props.initialshouldShowAddress !== null) {
      shouldShowAddress = _this.props.initialshouldShowAddress;
    }
    _this.state = { shouldShowAddress: shouldShowAddress };

    _this.renderAddressList = _this.renderAddressList.bind(_this);
    _this.renderPhoneNumbers = _this.renderPhoneNumbers.bind(_this);
    _this.onButtonClick = _this.onButtonClick.bind(_this);
    return _this;
  }

  _createClass(ContactInformation, [{
    key: 'renderAddressList',
    value: function renderAddressList(addressList) {
      if (addressList && addressList.length > 0) {
        var addressElements = addressList.map(function (address, index) {
          return _react2.default.createElement(
            'li',
            { key: index },
            _react2.default.createElement(
              'span',
              { className: 'bold' },
              address.addressTypes.toString() + " Address: "
            ),
            _react2.default.createElement('br', null),
            _react2.default.createElement(
              'span',
              null,
              address.asOneLine
            )
          );
        });
        return _react2.default.createElement(
          'ul',
          { className: 'nonstyledList' },
          addressElements
        );
      }
      return null;
    }
  }, {
    key: 'renderPhoneNumbers',
    value: function renderPhoneNumbers(phoneList) {
      if (phoneList && phoneList.length > 0) {
        var phoneElements = phoneList.map(function (phoneNumber, index) {
          return _react2.default.createElement(
            'li',
            { key: index },
            _react2.default.createElement(
              'span',
              { className: 'bold' },
              phoneNumber.lineType + " "
            ),
            _react2.default.createElement(
              'span',
              null,
              phoneNumber.num
            )
          );
        });
        return _react2.default.createElement(
          'ul',
          { className: 'nonstyledList' },
          phoneElements
        );
      }
      return null;
    }
  }, {
    key: 'onButtonClick',
    value: function onButtonClick() {
      var shouldShowAddress = !this.state.shouldShowAddress;
      this.setState({ shouldShowAddress: shouldShowAddress });
    }
  }, {
    key: 'render',
    value: function render() {
      var addressRender = this.renderAddressList(this.props.addressList);
      var phoneNumberRender = this.renderPhoneNumbers(this.props.phoneList);
      var shouldShowAddress = this.state.shouldShowAddress;

      return _react2.default.createElement(
        'span',
        null,
        _react2.default.createElement(
          'button',
          { onClick: this.onButtonClick, className: "ccd-btn contactInfoButton no-wrap" + (shouldShowAddress ? " collapseSectionBackground" : " expandSectionBackground") },
          'Contact'
        ),
        _react2.default.createElement(
          'div',
          { className: "contactDataContainer " + (shouldShowAddress ? "" : " hideButShowOnPrint") },
          addressRender || phoneNumberRender ? _react2.default.createElement(
            'div',
            null,
            addressRender,
            phoneNumberRender
          ) : _react2.default.createElement(
            'p',
            { className: 'bold' },
            'No contact information found.'
          )
        )
      );
    }
  }]);

  return ContactInformation;
}(_react.Component);

ContactInformation.propTypes = {
  phoneList: _propTypes2.default.array,
  addressList: _propTypes2.default.array,
  initialshouldShowAddress: _propTypes2.default.bool
};

exports.default = ContactInformation;


//////////////////
// WEBPACK FOOTER
// ./node_modules/updox-care-record-viewer/lib/reactComponents/ContactInformation.js
// module id = 477
// module chunks = 0